module.exports = __webpack_public_path__ + "img/logo-arasana.b33f2b3b.png";